module.exports = __webpack_public_path__ + "img/grid.208a85ba.jpg";